export default __webpack_public_path__ + "static/media/raei.ad78205d.jpg";